import { render, staticRenderFns } from "./BsTableHeaderToggle.vue?vue&type=template&id=6418662a&scoped=true"
import script from "./BsTableHeaderToggle.vue?vue&type=script&lang=js"
export * from "./BsTableHeaderToggle.vue?vue&type=script&lang=js"
import style0 from "./BsTableHeaderToggle.vue?vue&type=style&index=0&id=6418662a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418662a",
  null
  
)

export default component.exports